export default __webpack_public_path__ + "static/media/lumberinghulk.388e0da3.png";